import { useState, useCallback } from 'react';
import { AccordionState } from '../AccordionBase';

export interface UseAccordionStateResult {
  isCollapsed: boolean;
  accordionState: AccordionState;
  setAccordionState: (state: AccordionState) => void;
  handleToggleCollapse: (newIsCollapsed: boolean) => void;
  handleReviewButtonClick: () => void;
}

export const useAccordionState = (initialState: AccordionState = 'initial'): UseAccordionStateResult => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [accordionState, setAccordionState] = useState<AccordionState>(initialState);

  const handleToggleCollapse = useCallback(
    (newIsCollapsed: boolean) => {
      setIsCollapsed(newIsCollapsed);
      if (!newIsCollapsed && accordionState === 'initial') {
        setAccordionState('expanded');
      }
    },
    [accordionState],
  );

  const handleReviewButtonClick = useCallback(() => {
    setIsCollapsed(false);
    setAccordionState('expanded');
  }, []);

  return {
    isCollapsed,
    accordionState,
    setAccordionState,
    handleToggleCollapse,
    handleReviewButtonClick,
  };
};
